const MINIMUM_THUMB_SIZE = 20;

export const getThumbSize = (
	containerSize: number,
	contentSize: number,
	trackSize: number,
): number => {
	// Limit it proportionally to the track size, since it is not 1:1 with the panel size
	const size = Math.round((containerSize / contentSize) * trackSize);
	return Math.max(MINIMUM_THUMB_SIZE, size);
};

export const getThumbOffset = (
	scrollOffset: number,
	scrollSize: number,
	containerSize: number,
	trackSize: number,
	thumbSize: number,
): number => (scrollOffset / (scrollSize - containerSize)) * (trackSize - thumbSize);

export const getScrollFromPosition = (
	position: number,
	thumbSize: number,
	contentSize: number,
	trackSize: number,
	trackPosition: number,
): number => {
	const relativePosition = position - trackPosition;
	const newThumbOffset = relativePosition - thumbSize / 2;
	return (newThumbOffset / trackSize) * contentSize;
};
